import { render, staticRenderFns } from "./PaymentSuccessfull.vue?vue&type=template&id=5f2f7398&scoped=true&"
import script from "./PaymentSuccessfull.vue?vue&type=script&lang=js&"
export * from "./PaymentSuccessfull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2f7398",
  null
  
)

export default component.exports